import { SolidDownArrowIcon } from 'assets/icons/SolidDownArrowIcont'
import React, { PropsWithChildren } from 'react'

interface LearnMoreCardProps extends PropsWithChildren<{}> {
  title: string
  withArrow?: boolean
}

export const LearnMoreCard = ({ title, children, withArrow = true }: LearnMoreCardProps) => {
  return (
    <div className='mx-[16px] md:mx-10'>
      <div className='rounded-[30px] bg-white shadow-[1px_1px_20px_0px_rgba(0,0,0,0.12)]'>
        <div className='!px-6 !py-6 md:!p-15'>
          <h1 className='text-[#37A2BA] md:text-[24px] text-sm font-medium max-sm:text-center md:text-left sm:text-center mb-6 md:mb-10 md:leading-8 md:tracking-[0.4px]'>
            {title}
          </h1>
          {children}
        </div>
      </div>
      {withArrow && (
        <div className='py-4 sm:!py-10 flex justify-center items-center'>
          <SolidDownArrowIcon color='#00323D' className='h-3 w-3 sm:h-4 sm:w-4' />
        </div>
      )}
    </div>
  )
}